import React from "react";
import { Row, Col } from "../../../../grid";
import { Image } from "../../../../Image";
import RenderModal from "./RenderModal";
import { Paragraph } from "../../../../typography";

const RenderCampaignHeineken = ({ heinekenOffer }) => {
  if (heinekenOffer) {
    return (
      <Col xs={12}>
        <RenderModal
          title={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <React.Fragment>
              12 gratis glas ved køb af mindst 3 fustager Heineken
            </React.Fragment>
          }
        >
          <Row>
            <Col xs={12} textCenter>
              <Image
                name="diverse.heineken-tilbud-banner.png"
                maxHeight="200px"
              />
            </Col>
            <Col xs={12}>
              <Paragraph bold>
                12 gratis glas ved køb af mindst 3 fustager Heineken
              </Paragraph>
              <Paragraph>
                Når du køber mindst 3 fustager Heineken kan du få 12 glas gratis
                med din ordre (Max 12 gratis glas pr. ordre).
              </Paragraph>
              <Paragraph bold red>
                Sendes direkte til din adresse fra Royal Unibrew.
              </Paragraph>
            </Col>
          </Row>
        </RenderModal>
      </Col>
    );
  }
  return null;
};

// Export
export default RenderCampaignHeineken;
